/* global ga:false  */
import angular from 'angular';
import Raven from 'raven-js';

import { isQuotaExceededError } from '../helpers/isQuotaExceededError';

const wrapQuotaError = (cb) => {
  try {
    cb();
  } catch (e) {
    if (!isQuotaExceededError(e)) {
      Raven.captureException(e);
    }
  }
};

module.exports = angular.module('common.services.analytics', [
  require('angular-ui-router'),
])
  .factory('Analytics', ($rootScope, $http, Segment) => {
    return {
      event(category, action, label, extra) {
        wrapQuotaError(() => {
          // https://developers.google.com/analytics/devguides/collection/analyticsjs/events
          if (typeof (ga) === 'function') {
            ga('send', 'event', category, action, label, extra);
          }
        });

        wrapQuotaError(() => {
          // https://segment.com/docs/spec/track/
          Segment.track(label, extra);
        });

        wrapQuotaError(() => {
          // https://support.google.com/tagmanager/answer/6106961?hl=en
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: `${category}.${action}.${label}`, extra });
        });
      },

      aliasAndIdentify(id) {
        Segment.identify(id);
      },

      register(traits) {
        if (typeof (ga) === 'function') {
          ga('set', traits);
        }

        Segment.identify(traits);
      },
    };
  })
  .run(($rootScope, Analytics) => {
    $rootScope.$on('$stateChangeSuccess', (e, to) => {
      var remove = $rootScope.$on('$viewContentLoaded', () => {
        Analytics.event('state', 'change', to.name);
        remove();
      });
    });
  })
  .name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/analytics.js
 **/